/**
 * Regex email validation.
 * Returns a error text to fluent ui.
 * @param value The data that requires validation.
 */
export const validateEmail = (value) => {
  return /^[\w+]+([.-]?[\w+]+)*@\w+([.-]?\w+)*(\.\w{2,13})+$/.test(value);
};
